<template>
  <a-spin :spinning="confirmLoading">
    <a-tabs>
      <a-tab-pane tab="试卷设置" key="base" forceRender>
        <j-form-container :disabled="formDisabled">
          <!-- 主表单区域 -->
          <a-form :form="form" slot="detail">
            <a-row>
              <a-col :span="8">
                <a-form-item label="试卷状态" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                  <j-dict-select-tag
                    type="radioButton"
                    v-decorator="['paperStatus', validatorRules.paperStatus]"
                    :trigger-change="true"
                    dictCode="paper_status"
                    placeholder="请选择试卷状态"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="难度" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                  <j-dict-select-tag placeholder="请选择难度" v-decorator="['paperDifficulty', validatorRules.paperDifficulty]" dictCode="paper_difficulty" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="错题本" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                  <a-radio-group buttonStyle="solid" v-decorator="['revisionBook', validatorRules.revisionBook]">
                    <a-radio-button :value="0"> 关闭 </a-radio-button>
                    <a-radio-button :value="1"> 开放 </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="是否模拟卷" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                  <a-radio-group buttonStyle="solid" v-decorator="['isSimulation', validatorRules.isSimulation]">
                    <a-radio-button :value="0"> 正式卷 </a-radio-button>
                    <a-radio-button :value="1"> 模拟卷 </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="试卷样式" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                  <a-radio-group buttonStyle="solid" v-decorator="['paperStyle', validatorRules.paperStyle]">
                    <a-radio-button :value="1"> 单页 </a-radio-button>
                    <a-radio-button :value="2"> 一题一页 </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            <!-- <a-col :span="8">
              <a-form-item label="组卷方式" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                <a-radio-group buttonStyle="solid" v-decorator="['compositionMethod', validatorRules.paperStyle]">
                  <a-radio-button :value="0"> 固定题目 </a-radio-button>
                  <a-radio-button :value="1"> 抽题 </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col> -->
              <a-col :span="8">
                <a-form-item label="限时" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                  <a-tooltip title="考试时间限制，超出后自动交卷。">
                    <a-input-number
                      v-decorator="['timeLimit', validatorRules.timeLimit]"
                      :min="1"
                      placeholder="请填写考试限时"
                    />
                    <span> 分钟</span>
                  </a-tooltip>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="试卷库" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                  <j-dict-select-tag
                    type="list"
                    v-decorator="['paperType']"
                    :trigger-change="true"
                    dictCode="paper_type"
                    placeholder="请选择试卷库"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="试卷名" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['paperName', validatorRules.paperName]" placeholder="请输入试卷名"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="试卷介绍" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-editor v-decorator="['paperDesc',  { trigger: 'input' }]" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="试卷关键词" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                  <a-select
                    v-model="keywords"
                    placeholder="填写关键词，多个关键词用英文逗号分隔"
                    mode="tags"
                    style="width: 100%"
                    :token-separators="[',']"
                  >
                  </a-select>
                </a-form-item>
              </a-col>
              
              <a-col :span="12">
                <a-form-item label="关联课程" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                  <j-search-select-tag v-decorator="['courseId']" dict="teaching_course,course_name,id" />
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-textarea v-decorator="['comment']"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </j-form-container>
      </a-tab-pane>
      <a-tab-pane tab="题目设置" key="question" forceRender>
          <j-editable-table
            :ref="refKeys[0]"
            :loading="teachingPaperItemTable.loading"
            :columns="teachingPaperItemTable.columns"
            :dataSource="teachingPaperItemTable.dataSource"
            :maxHeight="300"
            :rowNumber="true"
            :dragSort="true"
            :rowSelection="true"
            :actionButton="true"
            showExport
            showImport
            @valueChange="handleValueChange"
          >
            <template slot="buttonAfter">
              <span>总分：{{totalScore}}</span>
            </template>
            <template slot="stemView" slot-scope="props">
              <a-popover title="题干预览" placement="right">
                <div slot="content" v-html="props.text"></div>
                <a-icon type="eye" theme="twoTone" />
              </a-popover>
            </template>
            <template slot="action" slot-scope="props">
              <TSelectQuestion :value="props.text" :multi="false" :showInput="false" @ok="(rows)=>selectQustionOk(rows, props)" buttonName="选择"/>
              <a-divider type="vertical"></a-divider>
              <a-button :disabled="props.row.questionId==''" type="primary" @click="handleEditQuestion(props)" icon="edit">编辑</a-button>
            </template>
            <template slot="buttonBefore">
              <TSelectQuestion :multi="true" :showInput="false" @ok="selectQustionBatch" buttonName="批量选择题目"/>
              <a-divider type="vertical"></a-divider>
            </template>
          </j-editable-table>
      </a-tab-pane>
    </a-tabs>
    <teaching-question-modal ref="modalForm" @ok="editQustionOk" />
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JEditor from '@/components/jeecg/JEditor'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import TeachingQuestionModal from './TeachingQuestionModal'
import TSelectQuestion from './selector/TSelectQuestion'
export default {
  name: 'TeachingPaperForm',
  mixins: [JEditableTableMixin],
  components: {
    JFormContainer,
    JDictSelectTag,
    JEditor,
    JSearchSelectTag,
    TeachingQuestionModal,
    TSelectQuestion
  },
  data() {
    return {
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      validatorRules: {
        paperStatus:{
          rules: [{ required: true, message: '请选择试卷状态!' }],
          initialValue: 0
        },
        paperName: {
          rules: [{ required: true, message: '请填写试卷名!' }],
        },
        compositionMethod: {
          rules: [{ required: true, message: '请选择组卷类型!' }],
          initialValue: 0,
        },
        paperStyle: {
          rules: [{ required: true, message: '请选择试卷样式!' }],
          initialValue: 1,
        },
        paperDifficulty: {
          rules: [{ required: true, message: '请输入难度!' }],
          initialValue: 1,
        },
        timeLimit:{
          rules: [{ required: true, message: '请输入限时!' }],
          initialValue: 60,
        },
        revisionBook: {
          rules: [{ required: true, message: '请选择是否开放错题本!' }],
          initialValue: 0,
        },
        isSimulation: {
          rules: [{ required: true, message: '请选择是试卷类型!' }],
          initialValue: 0,
        },
      },
      refKeys: ['teachingPaperItem'],
      tableKeys: ['teachingPaperItem'],
      activeKey: 'teachingPaperItem',
      // 试卷内容
      teachingPaperItemTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: '题目ID',
            key: 'questionId',
            width: '160px',
          },
          {
            title: '大标题',
            key: 'questionSection',
            type: FormTypes.input,
            width: '250px',
            placeholder: '请输入${title}',
            defaultValue: '',
          },
          {
            title: '题型',
            key: 'questionType',
            type: 'select',
            dictCode: 'question_type',
            width: '120px',
            defaultValue: '',
            disabled: true,
          },
          // {
          //   title: '题目名',
          //   key: 'questionName',
          //   type: FormTypes.popup,
          //   popupCode: 'questions',
          //   destFields: 'questionId,questionType,questionName,questionStem,questionScore',
          //   orgFields: 'id,question_type,question_name,question_stem,question_score',
          //   width: '400px',
          //   placeholder: '请输入${title}',
          //   defaultValue: '',
          // },
          {
            title: '题目名',
            key: 'questionName',
            type: FormTypes.input,
            width: '300px',
            disabled: true,
          },
          {
            title: '题干',
            key: 'questionStem',
            type: FormTypes.slot,
            slotName: 'stemView',
            width: '50px',
            placeholder: '',
            defaultValue: '0',
          },
          {
            title: '分数',
            key: 'questionScore',
            type: FormTypes.inputNumber,
            width: '100px',
            placeholder: '请输入${title}',
            defaultValue: '0',
          },
          {
            title: '操作',
            key: 'action',
            type: FormTypes.slot,
            slotName: 'action',
            width: '250px',
            placeholder: '',
            defaultValue: '0',
          },
          
        ],
      },
      url: {
        add: '/teaching/teachingPaper/add',
        edit: '/teaching/teachingPaper/edit',
        queryById: '/teaching/teachingPaper/queryById',
        teachingPaperItem: {
          list: '/teaching/teachingPaper/queryTeachingPaperItemByMainId',
        },
      },
      keywords: [],
      totalScore: 0
    }
  },
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: () => {},
      required: false,
    },
    //表单模式：false流程表单 true普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false,
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    formDisabled() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return true
        }
      }
      return false
    },
  },
  created() {
    //如果是流程中表单，则需要加载流程表单data
    this.showFlowData()
  },
  methods: {
    handleEditQuestion: function (obj) {
      this.$refs.modalForm.editById(obj.row.questionId);
      this.$refs.modalForm.title = "编辑";
      this.$refs.modalForm.disableSubmit = false;
    },
    selectQustionOk(rows, props){
      console.log(props);
      
      let { questionSection, id } = props.getValue()
      let row = rows[0]
      console.log(row);
      let values = [
        {
          rowKey: id,
          values: {
            'questionId': row.id,
            'questionName': row.questionName,
            'questionStem': row.questionStem,
            'questionScore': row.questionScore,
            'questionType': row.questionType,
            'questionSection': questionSection,
          },
        },
      ]
      this.$refs.teachingPaperItem.setValues(values)
    },
    selectQustionBatch(rows){
      for(let i=0; i<rows.length; i++){
        let row = rows[i]
        this.$refs.teachingPaperItem.push({
          'questionId': row.id,
          'questionName': row.questionName,
          'questionStem': row.questionStem,
          'questionScore': row.questionScore,
          'questionType': row.questionType,
          'questionSection': '',
        })
      }
    },
    editQustionOk(){

    },
    addBefore() {
      this.form.resetFields()
      this.teachingPaperItemTable.dataSource = []
    },
    getAllTable() {
      let values = this.tableKeys.map((key) => getRefPromise(this, key))
      return Promise.all(values)
    },
    /** 调用完edit()方法之后会自动调用此方法 */
    editAfter() {
      let fieldval = pick(
        this.model,
        'paperName',
        'paperType',
        'compositionMethod',
        'paperStatus',
        'paperDesc',
        'paperKeywords',
        'courseId',
        'paperDifficulty',
        'timeLimit',
        'revisionBook',
        'totalScore',
        'comment',
        'revisionBook',
        'isSimulation',
        'paperStyle'
      )
      this.totalScore = this.model.totalScore
      this.keywords = fieldval && fieldval.paperKeywords ? fieldval.paperKeywords.split(',') : []
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
      })
      // 加载子表数据
      if (this.model.id) {
        let params = { id: this.model.id }
        this.requestSubTableData(this.url.teachingPaperItem.list, params, this.teachingPaperItemTable)
      }
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)
      main.paperKeywords = this.keywords ? this.keywords.join(',') : ''
      console.log(allValues.tablesValue[0].values)
      return {
        ...main, // 展开
        teachingPaperItemList: allValues.tablesValue[0].values,
      }
    },
    handleValueChange(event) {
      this.calcTotalScore()
    },
    //计算总分
    calcTotalScore(){
      this.totalScore = 0
      getRefPromise(this, this.tableKeys[0]).then(v=>{
        v.getValues((error, values) => {
          for(let i in values){
            if(values[i].questionScore)
              this.totalScore += parseFloat(values[i].questionScore)
          }
        })
      })
    },
    //渲染流程表单数据
    showFlowData() {
      if (this.formBpm === true) {
        let params = { id: this.formData.dataId }
        getAction(this.url.queryById, params).then((res) => {
          if (res.success) {
            this.edit(res.result)
          }
        })
      }
    },
    validateError(msg) {
      this.$message.error(msg)
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'paperName',
          'paperType',
          'compositionMethod',
          'paperStatus',
          'paperDesc',
          'paperKeywords',
          'courseId'
        )
      )
    },
  },
}
</script>

<style scoped>
</style>